import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ICsvTemplate, IErrosCsv } from '../csv-template';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UploadplanilhaService } from '../uploadplanilha.service';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { AuthenticationService } from '../../services/authentication.service';
import { CnpjPipe, CnpjValidoPipe } from '../csv-posto.pipe';
import { environment } from 'src/environments/environment';
import { ToolsService } from 'src/app/services/tools.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Component({
  selector: 'app-uploadplanilha',
  templateUrl: './uploadplanilha.component.html',
  styleUrls: ['./uploadplanilha.component.scss'],
})
export class UploadplanilhaComponent implements OnInit {

  private snackBar = inject(SnackBarService);
  private authenticationService = inject(AuthenticationService);
  private dataService = inject(UploadplanilhaService);
  private toolsService = inject(ToolsService<any>);
  private localStorageService = inject(LocalStorageService);
  private cnpjPipe = inject(CnpjPipe);
  private cnpjValidoPipe = inject(CnpjValidoPipe);

  private router = inject(Router);
  private defaultColumns: string[] = [
    'codigoPosto',
    'cnpj',
    'chave',
    'razaoSocial',
    'combustivel',
    'nomeCombustivel',
    'precoTela',
    'sps',
    'status',
  ];

  private csvDefault = [
    'Cod. Posto',
    'CNPJ',
    'Chave',
    'Razao Social',
    'Cod. Combustivel',
    'Tipo de Combustivel',
    'Preco Bomba',
    'SPS',
  ];

  public isRedeEspecial: boolean = false;
  public mostrarTabelaComErros: boolean = true;
  public displayedColumns: string[] = this.defaultColumns;
  public dataSource = new MatTableDataSource<ICsvTemplate>();
  public existeLinhaModificada: boolean = false;

  private csvParaDownload = new MatTableDataSource<ICsvTemplate>();
  public labelDowbload: string = 'Baixar Modelo Arquivo CSV';
  private codCombustiveis: string[] = [];
  private csvDataOriginal: string[] = [];
  private csvDataOriginalPrecos: string[] = [];


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public loading: boolean = true;
  public mensagenserroscsv: Array<IErrosCsv> = [];
  public mostrarModal: boolean = false;

  ngOnInit() {
    var userGuid = this.localStorageService.getItem('guid');
    var url = `${environment.host_ctf_service}${CONFIG_URLS_API.API_PostoAutorizadoUploadCsv}?guid=${userGuid}`;

    this.toolsService.get(url).then((data: any) => {
      if (!data.retorno) this.router.navigate(['/preco-combustivel']);

      this.carregarDados();
    });
  }

  private setDataSource(data: ICsvTemplate[]): void {
    this.dataSource = new MatTableDataSource<ICsvTemplate>(data);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  private montarDadosOriginais(dadosOriginais: ICsvTemplate[]): void {
    
    dadosOriginais.map((row: any) => {
      let dadosNaoNumericos = `${row.codigoPosto};${this.cnpjPipe.transform(row.cnpj)};${
        row.chave
      };${row.combustivel};${row.nomeCombustivel}`;

      let precos = this.isRedeEspecial ? `${row.precoTela};${row.sps};${row.precoRedeEspecial}`: `${row.precoTela};${row.sps}`;
      //console.log(precos);
      this.csvDataOriginalPrecos.push(precos.toLocaleUpperCase());
      this.csvDataOriginal.push(dadosNaoNumericos.toLocaleUpperCase());
    });
  }

  private tratarSpsRedeEspecial(data: Array<ICsvTemplate>): Array<ICsvTemplate> {
    this.isRedeEspecial = data.some(
      (row) => row.redeEspecial
    );

    let dadosRedeEspecial = data.map((row) => {
      if(row.sps == 0){
        row.sps = row.precoTela;
      }


      if(this.isRedeEspecial && row.precoRedeEspecial == 0){
        row.precoRedeEspecial = row.sps;
      }

      return row;
    })

    return dadosRedeEspecial;

  }
  carregarDados(): void {
    this.loading = false;

    // Carregar lista de combustíveis válidos
    this.dataService.pegarCodCombustiveisValidos().subscribe((data) => {
      if (data.sucesso)
        this.codCombustiveis = data.retorno
          .filter((element) => element.descricaoCombustivel)
          .map((element) => element.descricaoCombustivel);
    });

    this.dataService.buscarDadosCsvPrecosPosto().subscribe((data) => {
      if (data.sucesso) {
        if (data.retorno.length === 0) {
          this.snackBar.flashMessage(
            'Não existem postos e preços cadastrados!',
            ['snackbar-info'],
            'Fechar',
            0
          );
        } else {
          this.labelDowbload = 'Baixar dados preços atuais';
        }

        let dadosRedeEspecial = this.tratarSpsRedeEspecial(data.retorno);

        this.montarDadosOriginais(dadosRedeEspecial);
        this.setDataSource(dadosRedeEspecial);
        this.csvParaDownload.data = dadosRedeEspecial;
        this.displayedColumns = this.isRedeEspecial
          ? (this.defaultColumns = [
            'codigoPosto',
            'cnpj',
            'chave',
            'razaoSocial',
            'combustivel',
            'nomeCombustivel',
            'precoTela',
            'sps',
            'precoRedeEspecial',
            'status',
          ])
          : this.defaultColumns;

        this.loading = true;
      } else {
        this.loading = true;
        this.snackBar.flashMessage(
          this.authenticationService.msgSessaoExpirada,
          ['snackbar-error'],
          'Fechar',
          0
        );
      }
    });
  }

  validarCnpj(cnpj: string): boolean {
    return this.cnpjValidoPipe.transform(cnpj);
  }
  validarCodigoPosto(codigoPosto: any): boolean {
    if (isNaN(codigoPosto)) {
      return false;
    }
    return codigoPosto > 0;
  }

  validarDadosNaoNumericosPorLinha(linha: string, numeroLinha: number): boolean {
    console.log(this.csvDataOriginal[numeroLinha], 'original');
    console.log(linha.toLocaleUpperCase(), 'linha');
    return this.csvDataOriginal[numeroLinha] !== linha.toLocaleUpperCase();
  }

  private verificarAlteracoesPrecos(linhaCompleta: string, numeroLinha: number): boolean {
    return this.csvDataOriginalPrecos[numeroLinha] !== linhaCompleta.toLocaleUpperCase()
  }

  private validarPrecos(pTela: any, pSps:any, pRedeespecial?: any): any[] {
    let precoTela = pTela !== undefined && pTela !== `` 
    ? (parseFloat(pTela.replace(',', '.')) * 100) /100 
    : 0;
    let precoSps = pSps !== undefined && pSps !== `` 
    ? (parseFloat(pSps.replace(',', '.')) *100) /100 
    : 0;

    let precoRedeEspecial = null;
    if(this.isRedeEspecial) {
      precoRedeEspecial = pRedeespecial !== undefined && pRedeespecial !== `` 
      ? (parseFloat(pRedeespecial.replace(',', '.')) *100) /100 
      : 0;
    }

    if(precoTela === 0){
      precoSps = 0;
      precoRedeEspecial = 0;
    }

    if(precoSps === 0){
      precoRedeEspecial = 0;
    }

    if(!this.isRedeEspecial)
      precoRedeEspecial = null;

    return [precoTela, precoSps, precoRedeEspecial];

  }

  private validateCSV(data: any[]): any[] {
    this.mensagenserroscsv = [];


    for (let i = 0; i < data.length; i++) {
      if (data[i]['CNPJ'] === undefined) continue;

      data[i]['codRetorno'] = 0;
      if (
        !data[i]['CNPJ'] ||
        !data[i]['Cod. Posto'] ||
        !data[i]['Chave'] ||
        !data[i]['Razao Social'] ||
        !data[i]['Cod. Combustivel'] ||
        !data[i]['Preco Bomba'] ||
        !data[i]['Tipo de Combustivel'] ||
        !data[i]['SPS']
      ) {
        data[i]['codRetorno'] = 99;
        data[i]['dscRetorno'] =
          'Campos obrigatórios "CNPJ, Cod. Posto ou Chave" não preenchidos';
      }

      let linha = `${data[i]['Cod. Posto']};${data[i]['CNPJ']};${data[i]['Chave']};${data[i]['Cod. Combustivel']};${data[i]['Tipo de Combustivel']}`;
      let linhaPrecos = this.isRedeEspecial
        ? `${data[i]['Preco Bomba']};${data[i]['SPS']};${data[i]['Preco RE']}`
        : `${data[i]['Preco Bomba']};${data[i]['SPS']}`;

      if(this.verificarAlteracoesPrecos(linhaPrecos.replace(/,/g, '.'), i)){
        data[i]['codRetorno'] = 2;
      }

      if (this.validarDadosNaoNumericosPorLinha(linha, i)) {
        data[i]['codRetorno'] = 1;
        this.mensagenserroscsv.push({
          chave: data[i]['Chave'],
          mensagem: `Erro na linha: ${ i + 2} Verifique os dados ${linha.replace(/;/g, ' ')}`.toUpperCase(),
        });

        this.mostrarTabelaComErros = false;
      }



      const p =  this.isRedeEspecial? this.validarPrecos(data[i]['Preco Bomba'].trim(),data[i]['SPS'].trim(),data[i]['Preco RE'].trim())
        : this.validarPrecos(data[i]['Preco Bomba'].trim(),data[i]['SPS'].trim());

      var preco_tela = p[0];
      var sps = p[1];
      var precoRedeEspecial = p[2];
      console.log(precoRedeEspecial);

      data[i]['precoTela'] = preco_tela;
      data[i]['sps'] = sps;
      data[i]['precoRedeEspecial'] = precoRedeEspecial;


      var codCombs = data[i]['Cod. Combustivel'].toUpperCase();

      if (!this.codCombustiveis.includes(codCombs)) {
        data[i]['codRetorno'] = 1;
        this.mensagenserroscsv.push({
          chave: data[i]['Cod. Posto'],
          mensagem: `Erro na linha ${
            i + 2
          }: Combustivel: ${codCombs} inválido. Verifique a chave ${
            data[i]['Chave']
          }`.toUpperCase(),
        });
      }

      if (isNaN(preco_tela) || isNaN(sps) || preco_tela < 0 || sps < 0) {
        this.mostrarTabelaComErros = true;
        data[i]['codRetorno'] = 1; // destacar no tela
        this.mensagenserroscsv.push({
          chave: data[i]['Chave'],
          mensagem: `Erro na linha ${
            i + 2
          }: "Preço Bomba" ou "SPS" é inválido. Verifique a chave ${
            data[i]['Chave']
          }`.toUpperCase(),
        });
      }

      if (
        this.isRedeEspecial &&
        (isNaN(precoRedeEspecial) || precoRedeEspecial < 0)
      ) {
        this.mostrarTabelaComErros = true;
        data[i]['codRetorno'] = 1; // destacar no tela
        this.mensagenserroscsv.push({
          chave: data[i]['Chave'],
          mensagem: `Erro na linha ${
            i + 2
          }:"Preço RE" é inválido. Verifique a chave ${data[i]['Chave']}`.toUpperCase(),
        });
      }

      if (sps > preco_tela) {
        data[i]['codRetorno'] = 1; // destacar no tela
        this.mensagenserroscsv.push({
          chave: data[i]['Chave'],
          mensagem: `Erro na linha ${
            i + 2
          }: SPS não pode ser maior que o Preço Bomba. Verifique a chave ${
            data[i]['Chave']
          }`.toUpperCase(),
        });
      }

      if(sps < preco_tela && precoRedeEspecial > sps){
        data[i]['codRetorno'] = 1; // destacar no tela
        this.mensagenserroscsv.push({
          chave: data[i]['Chave'],
          mensagem: `Erro na linha ${
            i + 2
          }: Preço RE não pode ser maior que o Preço SPS. Verifique a chave ${
            data[i]['Chave']
          }`.toUpperCase(),
        });
      }

      if (precoRedeEspecial > preco_tela) {
        data[i]['codRetorno'] = 1; // destacar no tela
        this.mensagenserroscsv.push({
          chave: data[i]['Chave'],
          mensagem: `Erro na linha ${
            i + 2
          }: Preço RE não pode ser maior que o Preço Bomba. Verifique a chave ${
            data[i]['Chave']
          }`.toUpperCase(),
        });
      }

      if (!this.validarCnpj(data[i]['CNPJ'])) {
        data[i]['codRetorno'] = 1; // destacar no tela
        this.mensagenserroscsv.push({
          chave: data[i]['Chave'],
          mensagem: `Erro na linha ${i + 2}: CNPJ: ${
            data[i]['CNPJ']
          } inválido. Verifique a chave ${data[i]['Chave']}`.toUpperCase(),
        });
      }

      if (!this.validarCodigoPosto(data[i]['Cod. Posto'])) {
        data[i]['codRetorno'] = 1; // destacar no tela
        this.mensagenserroscsv.push({
          chave: data[i]['Chave'],

          mensagem: `Erro na linha ${i + 2}: Código do posto: ${
            data[i]['Cod. Posto']
          } inválido.  Verifique a chave ${data[i]['Chave']}`.toUpperCase(),
        });
      }
    }

    return data;
  }
  private parseCSV(file: File) {
    this.mostrarTabelaComErros = true;
    this.mensagenserroscsv = [];

    const reader = new FileReader();
    reader.readAsText(file);

    reader.onload = () => {
      const csv = reader.result as string;
      const rows = csv.split('\n');

      const headers = rows?.shift()?.trim().split(';') || [];

      let data = rows.map((row) => {
        const cols = row.trim().split(';');
        const obj: any = {};

        if (cols.every((el) => el === '')) return;

        headers.forEach((header, index) => {
          obj[header] = cols[index];
        });

        return obj;
      });

      data = data.filter((d) => d != undefined);
      // Validar se qdt de linhas do csv é igual a qtd linhas originais baixadas
      if (data.length === this.csvParaDownload.data.length) {
        data = this.validateCSV(data);

        data = data.sort((a, b) => {
          return b.codRetorno - a.codRetorno;
        });

        this.existeLinhaModificada = data.some((el) => el.codRetorno === 2);
        this.dataSource.data = data.map((row: any) => {
          row['codigoPosto'] = row['Cod. Posto'];
          row['cnpj'] = row['CNPJ'];
          row['chave'] = row['Chave'];
          row['razaoSocial'] = row['Razao Social'];
          row['combustivel'] = row['Cod. Combustivel'];
          row['nomeCombustivel'] = row['Tipo de Combustivel'];
          row['status'] = null;
          return row;
        });



        this.labelDowbload = 'Baixar Dados Precos Posto';
      } else {
        this.mostrarTabelaComErros = false;
        this.mensagenserroscsv.push({
          chave: 'ERRO',
          mensagem: `Quantidade de linhas do arquivo não confere com arquivo que foi baixado, corrija os dados ou baixe a planilha novamente.`.toUpperCase(),
        });
      }
    };
  }


  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    const elem = event.target as HTMLInputElement;
    if (file) {
      this.dataSource.data = [];
      this.existeLinhaModificada = false;

      this.mensagenserroscsv = [];
      this.parseCSV(file);
    }
    elem.value = '';
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private verificarErrosRetorno(dados: Array<ICsvTemplate>): void {
    let comErros = dados.filter(
      (el) => el.codRetorno !== 0 && el.codRetorno !== 99
    );
    comErros.forEach((el: ICsvTemplate) => {
      this.mensagenserroscsv.push({
        chave: el.chave,
        mensagem:
          `${el.dscRetorno}. Verifique a chave ${el.chave}`.toUpperCase() ||
          'Erro no envio de dados'.toUpperCase(),
      });
    });

    if (comErros.length > 0) {
      this.snackBar.flashMessage(
        'Dados atualizados, mais novos erros foram encontrados.',
        ['snackbar-error'],
        'Fechar',
        0
      );
    }else{
      this.snackBar.flashMessage(
        'Dados enviados com sucesso',
        ['snackbar-info'],
        'Fechar',
        0
      );
    }


  }

  submitData() {
    this.loading = false;
    this.mostrarModal = false;
    this.existeLinhaModificada = false;
    const csvData: ICsvTemplate[] = this.dataSource.data.map((row: any) => ({
      codigoPosto: row['codigoPosto'],
      cnpj: row['chave'].substr(0, row['chave'].length - 1), // remover a letra combustivel
      chave: row['chave'],
      razaoSocial: row['razaoSocial'],
      redeEspecial: row['redeEspecial'] || false,
      combustivel: row['combustivel'],
      nomeCombustivel: row['nomeCombustivel'],
      precoTela: row['precoTela'],
      sps: row['sps'],
      precoRedeEspecial: row['precoRedeEspecial'] || 0,
      status: null,
      codRetorno: 0,
    }));

    this.dataService.uploadPlanilha(csvData).subscribe((response) => {
      if (!response.sucesso) {
        this.snackBar.flashMessage(
          response.mensagens ? response.mensagens[0] : 'Erro ao enviar dados',
          ['snackbar-error'],
          'Fechar',
          0
        );
        this.loading = true;
        return;
      }
      let dadosRedeEspecial = this.tratarSpsRedeEspecial(response.retorno);
      this.verificarErrosRetorno(dadosRedeEspecial);
      this.setDataSource(dadosRedeEspecial);
      this.loading = true;

    });
  }

  baixarModelo() {
    if (this.csvParaDownload.data.length > 0) {
      this.baixarDadosPrecosPosto();
      return;
    }

    var template = this.isRedeEspecial
      ? this.dataService.buscarDadosCsvTemplate(true)
      : this.dataService.buscarDadosCsvTemplate();

    template.subscribe((data: string) => {
      this.downloadFile(data, 'modelo-upload-precos-postos.csv');
    });
  }

  private baixarDadosPrecosPosto() {
    this.csvDefault = [
      'Cod. Posto',
      'CNPJ',
      'Chave',
      'Razao Social',
      'Cod. Combustivel',
      'Tipo de Combustivel',
      'Preco Bomba',
      'SPS',
    ];

    this.isRedeEspecial ? this.csvDefault.push('Preco RE') : null;
    var cab = this.csvDefault.join(';') + '\n';

    this.csvParaDownload.data.forEach((element) => {
      var linha = [
        element.codigoPosto,
        this.cnpjPipe.transform(element.cnpj),
        element.chave,
        element.razaoSocial,
        element.combustivel,
        element.nomeCombustivel,
        element.precoTela.toLocaleString('pt-BR'),
        element.sps.toLocaleString('pt-BR'),
      ];
      this.isRedeEspecial
        ? linha.push(element.precoRedeEspecial.toLocaleString('pt-BR'))
        : null;
      cab += linha.join(';') + '\n';

      // se for ultima linha, remover o \n
      if (
        element ===
        this.csvParaDownload.data[this.csvParaDownload.data.length - 1]
      ) {
        cab = cab.slice(0, cab.length - 1);
      }
    });

    this.downloadFile(cab, 'precos-postos.csv');
  }
  formatToTwoDecimal(value: number): number {
    return parseFloat(value.toFixed(2));
  }
  onValueChange(value: number): void {
    value = parseFloat(value.toFixed(2));
  }

  public verificarErros(row: any): void {
    const chave = row['chave'];
    let precoRedeEspecial: any  = 0;
    //${linha.replace(/;/g, ' ')}`,

    try {


      const precoTela = isNaN(row['precoTela'])
        ? Math.trunc(parseFloat(row['precoTela'].replace(/,/d, '.')) *100) / 100
        : Math.trunc(parseFloat(row['precoTela']) *100) / 100;
      const precoSps = isNaN(row['sps'])
        ? Math.trunc(parseFloat(row['sps'].replace(/,/d, '.')) *100) / 100
        : Math.trunc(parseFloat(row['sps']) *100) / 100;
      if(this.isRedeEspecial)
        precoRedeEspecial = isNaN(row['sps'])
        ? Math.trunc(parseFloat(row['precoRedeEspecial'].replace(/,/d, '.')) *100) / 100
        : Math.trunc(parseFloat(row['precoRedeEspecial']) *100) / 100;

      row['precoTela']= precoTela;
      if (precoTela == 0) {
        row['sps'] = 0;
        row['precoRedeEspecial'] = 0;
      }

      row['sps'] = precoSps;
      row['precoRedeEspecial'] = precoRedeEspecial;

      row.codRetorno = 0;
      row.dscRetorno = ''


      this.mensagenserroscsv = this.mensagenserroscsv.filter(
        (el) => el.chave?.toUpperCase() !== chave.toUpperCase()
      );


      if (isNaN(precoSps) || isNaN(precoRedeEspecial) || isNaN(precoTela)) {
        throw new Error(`Preço de combustivel inválido, corrija a chave ${row.chave}`);
      }

      if (precoSps < 0 || precoRedeEspecial < 0 || precoTela < 0) {
        throw new Error(`Nenhum preço de combustivel não pode ser negativo, corrija a chave ${row.chave}`);
      }

      if (precoSps > precoTela) {
        throw new Error(
          `Preço de SPS não pode ser maior que o preço de tela, corrija a chave ${row.chave}`
        );
      }

      if(precoRedeEspecial > precoSps){
        throw new Error(
          `Preço RE não pode ser maior que Preço SPS, corrija a chave ${row.chave}`
        );
      }

      if(!this.isRedeEspecial){
        precoRedeEspecial = null;
        row['precoRedeEspecial'] = precoRedeEspecial;
      }

    } catch (e: any) {
      row.codRetorno = 99;
      row.dscRetorno = e.message;
      this.mensagenserroscsv.push({ chave: chave, mensagem: e.message.toUpperCase() });
    }
  }

  private downloadFile(
    data: string,
    filename: string,
    type: string = 'text/csv;charset=UTF-8'
  ) {
    const blob = new Blob(['\ufeff', data], { type: type });
    const url = window.URL.createObjectURL(blob);
    //window.open(url);

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename; // Defina o nome do arquivo aqui
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  verificarMudancas(el: ICsvTemplate): string {
    switch (el.codRetorno) {
      case 1: return  'erros';
      case 99: return  'erros';
      case 2: return 'alteracoes';
      default: return  '';
    }
  }
}
